import heroImg from '@/assets/babcock-hero.jpg';
import logoMark from '@/assets/babcock-ranch-mark.svg';

// Hero banner used at the top of HomePage. A wide photo of the Lake
// Babcock Lookout tower with the official circular Babcock Ranch logo
// mark stacked above a wordmark, both centered over the sky portion of
// the image. User approved shipping the real logo asset (private
// family app, minimal trademark risk).

export function HeroBanner() {
  return (
    <div
      className="hero-banner"
      role="img"
      aria-label="Babcock Ranch — Lake Babcock Lookout tower at golden hour"
    >
      <img className="hero-banner__img" src={heroImg} alt="" loading="eager" fetchPriority="high" />
      <div className="hero-banner__scrim" aria-hidden />
      <div className="hero-banner__servicemark" aria-label="Babcock Ranch">
        <img
          className="hero-banner__logomark"
          src={logoMark}
          alt=""
          aria-hidden
          width={56}
          height={56}
        />
        <span className="hero-banner__wordmark-wrap">
          <span className="hero-banner__wordmark">Babcock Ranch</span>
          <span className="hero-banner__reg" aria-hidden>
            ®
          </span>
        </span>
      </div>
    </div>
  );
}
